import React, {Component} from "react"
import styles from "./LogoutButton.module.css"

import {ReactComponent as LogoutIcon} from "./img/logout.svg"

interface Props {
    onClick: (e?) => void
}

export class LogoutButton extends Component<Props, {}> {
    public render() {
        return (
            <button className={styles.root} onClick={this.props.onClick} title="Log out">
                <LogoutIcon className={styles.icon} width="14" height="14" />
                <span className={styles.text}>Log out</span>
            </button>
        )
    }
}
